<template>
<!-- fixedBtn 제거시 퍼블리싱과 동일 -->
<div :class="{'btnBox col2':true,'fixedBtn':fixed}">
    <span v-if="!disabledBefore"><a class="btnL bGray" @click="back">이전</a></span>
    <slot>
        <span><a class="btnL" @click="$emit('submit')">확인</a></span>
    </slot>
</div>
</template>

<script>
export default {
  props: {
        disabledBefore: { type: Boolean, default: false },
        before: { type: String, default:null},
        fixed: { type: Boolean, default:true}
    },
  methods:{
      back(){
        history.back();
      }
  }
}
</script>

